import { Alert, Button, Grid, Snackbar, Theme, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { contactRoutes } from '../../../routes';
import { acceptCall, endCall } from '../../../store/dialer';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import DisplayPhoneNumber from '../../Shared/DisplayPhoneNumber/DisplayPhoneNumber';
import { IncomingCallContactInfo } from './IncomingCallContactInfo';

export function IncomingCall() {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();
    const history = useHistory();

    const twilioCall = useAppSelector(state => state.dialer.twilioCall);

    const [isOpen, setIsOpen] = useState(false);

    const onCloseHandler = () => {
        //do nothing - keep it open on backdrop click
    };

    const onDismissHandler = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        if (twilioCall && twilioCall.status === 'pending') {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [twilioCall]);

    const handleAccept = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        dispatch(acceptCall());
    };

    const handleDecline = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        dispatch(endCall());
    };

    const handleAlertClick = () => {
        if (twilioCall?.parameters.contactId) {
            history.push(contactRoutes.setDetails(twilioCall?.parameters.contactId));
        }
    };

    return (
        <Snackbar
            open={isOpen}
            onClose={onCloseHandler}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            sx={{ cursor: 'pointer' }}
        >
            <Alert
                elevation={5}
                className={classes.paper}
                severity="info"
                onClick={handleAlertClick}
            >
                <Grid container spacing={3} flexDirection="column" p={2} justifyContent="center">
                    <Grid item>
                        <Typography variant="h5" align="center">
                            {twilioCall?.parameters.contactName || 'Unknown Caller'}
                        </Typography>
                    </Grid>
                    {twilioCall?.parameters.from && (
                        <Grid item>
                            <Typography variant="h6" align="center">
                                <DisplayPhoneNumber phoneNumber={twilioCall.parameters.from} />
                            </Typography>
                        </Grid>
                    )}
                    <Grid item>
                        <Typography variant="body1" align="center">
                            Incoming Call
                        </Typography>
                    </Grid>
                    <IncomingCallContactInfo contactId={twilioCall?.parameters.contactId} />
                    <Grid container item spacing={2} justifyContent="center">
                        <Grid item>
                            <Button
                                variant="contained"
                                color="success"
                                size="large"
                                onClick={handleAccept}
                            >
                                Accept
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="error"
                                size="large"
                                onClick={handleDecline}
                            >
                                Ignore
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Alert>
        </Snackbar>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    paper: {
        // position: 'absolute',
        // top: '50%',
        // left: '50%',
        // transform: 'translate(-50%, -50%)',
        width: 350,
    },
}));
